"use client";

import { ChartLineHintWindow } from "@/components/hlidaci-pes/chart-line-interactive/ChartLineHintWindow";
import { WatchDogResultsHintWindow } from "@/components/hlidaci-pes/WatchDogResultsHintWindow";
import { WatchDogTopHintWindow } from "@/components/hlidaci-pes/watchdog-page/WatchDogTopHintWindow";

type WatchDogPageHintsProps = {
  watchDogCount: number;
  activeViewLabel: string;
  activeViewDescription: string;
  isTopHintOpen: boolean;
  onToggleTopHint: () => void;
  isResultsHintOpen: boolean;
  onToggleResultsHint: () => void;
  isGraphView: boolean;
  hasSelectedDog: boolean;
};

export function WatchDogTopHint({
  watchDogCount,
  activeViewLabel,
  activeViewDescription,
  isTopHintOpen,
  onToggleTopHint,
}: Pick<
  WatchDogPageHintsProps,
  | "watchDogCount"
  | "activeViewLabel"
  | "activeViewDescription"
  | "isTopHintOpen"
  | "onToggleTopHint"
>) {
  return (
    <WatchDogTopHintWindow
      watchDogCount={watchDogCount}
      activeViewLabel={activeViewLabel}
      activeViewDescription={activeViewDescription}
      isOpen={isTopHintOpen}
      onToggle={onToggleTopHint}
    />
  );
}

export function WatchDogResultsHint({
  isGraphView,
  hasSelectedDog,
  isResultsHintOpen,
  onToggleResultsHint,
}: Pick<
  WatchDogPageHintsProps,
  "isGraphView" | "hasSelectedDog" | "isResultsHintOpen" | "onToggleResultsHint"
>) {
  if (isGraphView) {
    return (
      <ChartLineHintWindow
        isOpen={isResultsHintOpen}
        onToggle={onToggleResultsHint}
      />
    );
  }

  if (!hasSelectedDog) return null;

  return (
    <WatchDogResultsHintWindow
      isOpen={isResultsHintOpen}
      onToggle={onToggleResultsHint}
    />
  );
}
